export const REBUZZ_SELECTED_OPTIONS = {
  CONTENT: 'content',
  PROMOTION: 'promotion',
};
